import { render } from "./chartG.vue?vue&type=template&id=ce6af408"
import script from "./chartG.vue?vue&type=script&lang=ts"
export * from "./chartG.vue?vue&type=script&lang=ts"
script.render = render

export default script